/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UpdateTag/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function UpdateTag({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/UpdateTag"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginTop="auto"
 marginLeft="auto"
 marginRight="auto"
 marginBottom={dtSpaceS}
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
 text="Calendar status & updates"
 goTo="https://getgreyfinch.notion.site/New-Greyfinch-Calendar-early-adopters-10afaea570cd8071a189dde725997f8c"
/>
{children}
</React.Fragment>)
}